import {useQuery} from '@tanstack/react-query';
import {getMyInquiryList} from '@/api/help/my-inquiry';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {formatMyInquiry} from '@/utils/help/inquiry';

export const myInquiryListQueryKey = ['help', 'my-inquiry', 'list'];

export const useGetMyInquiryList = ({page}: {page: number}) => {
  const {isMobile} = useHelpContext();
  return useQuery({
    queryKey: [...myInquiryListQueryKey, page],
    queryFn: () => getMyInquiryList({page}),
    select: ({data}) => ({
      inquiryList: data.qnaList.map((inquiry) => formatMyInquiry(inquiry)),
      totalPages: Math.ceil(data.qnaListCount / 10),
      currentPage: data.pageNo,
    }),
    staleTime: 0,
    enabled: !isMobile,
  });
};
